const className = "react-calendar__tile";

export default function WeekNumber(props) {
  const { onClickWeekNumber, weekNumber } = props;

  const children = <span>{weekNumber}</span>;

  if (onClickWeekNumber) {
    const {
      date,
      onClickWeekNumber: onClick,
      weekNumber,
      ...otherProps
    } = props;

    return (
      <button
        {...otherProps}
        className={className}
        onClick={(event) => onClick(weekNumber, date, event)}
        type="button"
      >
        {children}
      </button>
    );
  } else {
    const { date, onClickWeekNumber, weekNumber, ...otherProps } = props;

    return (
      <div {...otherProps} className={className}>
        {children}
      </div>
    );
  }
}
